export const pkey = (p) => p.id || p.name;

// C = chosen captain (slot.captain) or highest rated; V = next highest.
export const armbandsFor = (xi = []) => {
  const ranked = xi.filter((s) => s.player).sort((a, b) => b.player.rating - a.player.rating);
  const cap = ranked.find((s) => s.captain) || ranked[0];
  const out = {};
  if (!cap) return out;
  out[pkey(cap.player)] = "C";
  const vice = ranked.find((s) => s !== cap);
  if (vice) out[pkey(vice.player)] = "V";
  return out;
};

export const withCaptain = (xi = [], key) => {
  const ranked = xi.filter((s) => s.player).sort((a, b) => b.player.rating - a.player.rating);
  const capKey = key && ranked.some((s) => pkey(s.player) === key) ? key : ranked[0] && pkey(ranked[0].player);
  return xi.map((s) => ({ ...s, captain: !!s.player && pkey(s.player) === capKey }));
};

// Split team season points across the XI weighted by rating (captain x2), summing exactly to total.
export const splitPoints = (xi = [], total = 0) => {
  const capKey = Object.entries(armbandsFor(xi)).find(([, v]) => v === "C")?.[0];
  const ps = xi.filter((s) => s.player).map((s) => s.player);
  const weight = (p) => p.rating * (pkey(p) === capKey ? 2 : 1);
  const sum = ps.reduce((a, p) => a + weight(p), 0);
  if (!sum) return {};
  const raw = ps.map((p) => ({ k: pkey(p), v: (total * weight(p)) / sum }));
  const out = Object.fromEntries(raw.map((r) => [r.k, Math.floor(r.v)]));
  let left = total - Object.values(out).reduce((a, b) => a + b, 0);
  [...raw].sort((a, b) => (b.v % 1) - (a.v % 1)).forEach((r) => {
    if (left > 0) { out[r.k] += 1; left -= 1; }
  });
  return out;
};

export const starOf = (points = {}) => {
  const top = Object.entries(points).sort((a, b) => b[1] - a[1])[0];
  return top ? top[0] : null;
};
